"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _EventType = _interopRequireDefault(require("../events/EventType.js"));

var _Interaction = _interopRequireWildcard(require("./Interaction.js"));

var _condition = require("../events/condition.js");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/interaction/KeyboardZoom
 */


/**
 * @typedef {Object} Options
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.targetNotEditable}.
 * @property {number} [delta=1] The zoom level delta on each key press.
 */

/**
 * @classdesc
 * Allows the user to zoom the map using keyboard + and -.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardPan~KeyboardPan}.
 * @api
 */
var KeyboardZoom =
/** @class */
function (_super) {
  __extends(KeyboardZoom, _super);
  /**
   * @param {Options} [opt_options] Options.
   */


  function KeyboardZoom(opt_options) {
    var _this = _super.call(this) || this;

    var options = opt_options ? opt_options : {};
    /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */

    _this.condition_ = options.condition ? options.condition : _condition.targetNotEditable;
    /**
     * @private
     * @type {number}
     */

    _this.delta_ = options.delta ? options.delta : 1;
    /**
     * @private
     * @type {number}
     */

    _this.duration_ = options.duration !== undefined ? options.duration : 100;
    return _this;
  }
  /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides whether to zoom in or out (depending on whether the
   * key pressed was '+' or '-').
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @this {KeyboardZoom}
   */


  KeyboardZoom.prototype.handleEvent = function (mapBrowserEvent) {
    var stopEvent = false;

    if (mapBrowserEvent.type == _EventType["default"].KEYDOWN || mapBrowserEvent.type == _EventType["default"].KEYPRESS) {
      var keyEvent =
      /** @type {KeyboardEvent} */
      mapBrowserEvent.originalEvent;
      var charCode = keyEvent.charCode;

      if (this.condition_(mapBrowserEvent) && (charCode == '+'.charCodeAt(0) || charCode == '-'.charCodeAt(0))) {
        var map = mapBrowserEvent.map;
        var delta = charCode == '+'.charCodeAt(0) ? this.delta_ : -this.delta_;
        var view = map.getView();
        (0, _Interaction.zoomByDelta)(view, delta, undefined, this.duration_);
        keyEvent.preventDefault();
        stopEvent = true;
      }
    }

    return !stopEvent;
  };

  return KeyboardZoom;
}(_Interaction["default"]);

var _default = KeyboardZoom;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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